<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :isBlur="true" :title="'전달 완료'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; margin-top: 80px; text-align: center;">
            <div>
                <ProfileImage :imagePath="opponentMemberInfo.image_path" style="width: 70px;"></ProfileImage>
                <div style="margin-top: 4px; color: #b5aaa3; font-weight: 700; font-size: 12px; line-height: 24px;">{{ teamInfo.name }}</div>
                <div style="font-weight: 500; font-size: 14px; line-height: 18px; margin-top: 20px;">훈련 영상 보내기</div>
                <div style="margin-top: 4px; font-weight: 800; font-size: 20px; line-height: 32px;">피드백을 기다리는 동안,<br>훈련으로 한층 더 성장해보세요</div>
            </div>
        </div>
        <div style="padding: 0 12px; margin-bottom: 40px;">
            <div @click="goToHome" style="height: 48px; border-radius: 12px; background-color: #210f03; color: var(--color-main); line-height: 48px; text-align: center; font-weight: 700; font-size: 14px;">홈으로</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'

export default {
    name: 'SendTrainingVideoComplete',
    components: {
        MercenaryHeader, ProfileImage
    },
    props: {
        teamInfo: {
            type: Object,
            default: () => {}
        },
        opponentMemberInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            
        }
    },
    created() {
        console.log(this.opponentMemberInfo)
        console.log(this.teamInfo)
    },
    methods: {
        goToHome() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/home' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        }
    }
}
</script>

<style scoped>

</style>